export default __webpack_public_path__ + "static/media/MembershipForm.89ba8389.pdf";